import _ from 'lodash';
import { Form, Spin } from 'antd';
import { useLocation } from 'react-router-dom';
import CardAccordion from 'components/CardAccordion/CardAccordion';
import { useSendControlDataMutation } from 'store/features/api/apiSlice';
import { forwardRef, useImperativeHandle, useMemo, useState } from 'react';
import { formatNumber } from '../../lease-record-management-v9-new-version/utils/helperFunc';
import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

const accordionSx = {
	mb: 2,
	border: '1px solid #e6ebf2',
	borderRadius: '10px',
	boxShadow: 'none',
	overflow: 'hidden',
};

const accordionHeaderSx = {
	px: 2,
	py: 1.5,
	backgroundColor: '#f8fafc !important',
	borderBottom: '1px solid #eef2f7',
};

const accordionTitleSx = {
	fontSize: '15px !important',
	fontWeight: '600 !important',
	color: '#1f2937',
};

const LeaseV9NewTrailModeBalanceView = forwardRef((_props, ref) => {
	const form = Form.useFormInstance();
	const { state } = useLocation();
	const [sendControlDataForShowAll, { data: generalLedgerData, isLoading: isSendControlDataLoading }] = useSendControlDataMutation();
	const [previousPayload, setPreviousPayload] = useState(null);

	const loadData = async () => {
		const payloadData = {
			leaseId: form.getFieldValue('leaseId'),
		};

		const convertJson = JSON.stringify(payloadData);
		const convertBase64 = btoa(convertJson);

		const formattedPayload = {
			data: convertBase64,
			processCode: state?.processCode,
			scriptName: 'lease-controller-schedule-get-findata',
			payloadData: payloadData,
		};

		// Check if current payload is same as previous to avoid unnecessary API call
		const currentPayloadStr = JSON.stringify(formattedPayload);
		const previousPayloadStr = previousPayload ? JSON.stringify(previousPayload) : null;

		if (previousPayloadStr !== currentPayloadStr) {
			await sendControlDataForShowAll(formattedPayload);
			setPreviousPayload(formattedPayload);
		}
	};
	useImperativeHandle(ref, () => ({
		loadData,
	}));
	// useEffect(() => {
	// 	loadData();
	// }, []);

	// const columnData = useMemo(
	// 	() => [
	// 		{
	// 			id: 'recordDocId',
	// 			width: '5%',
	// 			align: 'center',
	// 			accessor: (data) => data?.latestProcessGroup?.recordDocId,
	// 			cellAlign: 'center',
	// 			Header: 'Document No',
	// 			cellSx: { fontSize: '13px' },
	// 		},
	// 		{
	// 			id: 'recordInputDate',
	// 			width: '5%',
	// 			align: 'center',
	// 			accessor: (data) => {
	// 				return dayjs(data?.latestProcessGroup?.recordInputDate?.dateString).format('YYYY-MM-DD');
	// 			},
	// 			cellAlign: 'center',
	// 			Header: 'Document Date',
	// 			cellSx: { fontSize: '13px' },
	// 		},

	// 		{
	// 			id: 'referenceId',
	// 			width: '5%',
	// 			align: 'center',
	// 			accessor: (data) => data?.latestProcessGroup?.serialNumber,
	// 			cellAlign: 'center',
	// 			Header: 'Reference Id',
	// 			cellSx: { fontSize: '13px' },
	// 		},
	// 		{
	// 			id: 'recordCreationDateTime',
	// 			width: '5%',
	// 			align: 'center',
	// 			accessor: (data) => {
	// 				return dayjs(data?.latestProcessGroup?.creationDateTime?.dateString).format('YYYY-MM-DD');
	// 			},
	// 			cellAlign: 'center',
	// 			Header: 'Reference Date',
	// 			cellSx: { fontSize: '13px' },
	// 		},
	// 		{
	// 			id: 'description',
	// 			width: '5%',
	// 			align: 'left',
	// 			accessor: (data) => data?.description,
	// 			cellAlign: 'left',
	// 			Header: 'Description',
	// 			cellSx: { fontSize: '13px' },
	// 		},
	// 		{
	// 			id: 'processStatus',
	// 			width: '5%',
	// 			align: 'center',
	// 			accessor: (data) => data?.latestProcessGroup?.processStatus,
	// 			cellAlign: 'center',
	// 			Header: 'Type',
	// 			cellSx: { fontSize: '13px' },
	// 		},

	// 		{
	// 			id: 'total',
	// 			width: '5%',
	// 			align: 'right',
	// 			accessor: 'total',
	// 			cellAlign: 'center',
	// 			Header: 'Amount',
	// 			Cell: (cell) => {
	// 				const debit = cell?.row?.original?.debit ? parseFloat(cell?.row?.original?.debit) : 0;
	// 				const credit = cell?.row?.original?.credit ? parseFloat(cell?.row?.original?.credit) : 0;
	// 				const total = isNaN(debit) ? 0 : debit - (isNaN(credit) ? 0 : credit);

	// 				return (
	// 					<Typography align="right" sx={{ fontSize: '13px !important' }}>
	// 						{total !== 0 ? (total > 0 ? formatNumber(total, 2) : '(' + formatNumber(Math.abs(total), 2) + ')') : ''}
	// 					</Typography>
	// 				);
	// 			},
	// 		},

	// 		{
	// 			id: 'comulativeAmount',
	// 			width: '5%',
	// 			align: 'right',
	// 			accessor: 'comulativeAmount',
	// 			cellAlign: 'right',
	// 			Header: 'Cumulative Amount',
	// 			cellSx: { fontSize: '13px' },
	// 		},
	// 	],
	// 	[]
	// );

	const headSequence = [
		'RoU Asset - Initial Recognition',
		'RoU Asset - Modification',
		'RoU Asset - Prepayments',
		'RoU Asset - Upfront Payment',
		'RoU Asset - Indirect Costs',
		'RoU Asset - Cash Incentive',
		'RoU Asset - Knock Off',
		'Security Deposit - Security Deposit',
		'Lease Liability - Initial Recognition',
		'Lease Liability - Modification',
		'Lease Liability - Payment',
		'Lease Liability - Interest',
		// 'Interest Expense',
		// 'Depreciation - RoU',
		// 'Accum Depreciation - RoU',
		'Accum Depreciation - RoU - Knock Off',
		'A/P Control Ledger - Prepayments',
		'A/P Control Ledger - Upfront Payment',
		'A/P Control Ledger - Indirect Costs',
		'A/P Control Ledger - Security Deposit',
		'A/P Control Ledger - Payment',
		'A/R Control Ledger - Cash Incentive',
		'Interest Expense - Interest',
		'Depreciation - RoU - Depreciation',
		'Accum Depreciation - RoU - Depreciation',
	];

	const groupDataByHead = (data) => {
		if (!Array.isArray(data)) return null;

		// First, group the data by the 'head' field
		const grouped = _.groupBy(data, 'head');

		// Create an ordered result based on headSequence
		const result = headSequence
			.filter((head) => grouped[head]) // Only include heads that exist in the data
			.map((head) => {
				const values = grouped[head];
				let runningTotal = 0;

				// Calculate running totals and format data
				const indexedValues = values.map((item, index) => {
					const { head, ...rest } = item;

					// Calculate the value for this row (debit - credit)
					const debit = parseFloat(item.debit || 0);
					const credit = parseFloat(item.credit || 0);
					const rowValue = debit - credit;

					// Update running total
					runningTotal += rowValue;

					// Format the cumulative amount
					const formattedCumulative =
						runningTotal !== 0
							? runningTotal > 0
								? formatNumber(runningTotal, 2)
								: '(' + formatNumber(Math.abs(runningTotal), 2) + ')'
							: '';

					return {
						...rest,
						index,
						comulativeAmount: formattedCumulative,
					};
				});

				return {
					head,
					value: indexedValues,
					finalCumulativeAmount: indexedValues.length > 0 ? indexedValues[indexedValues.length - 1].comulativeAmount : '',
				};
			});

		return result;
	};
	const filteredData = Array.isArray(generalLedgerData?.responseData)
		? generalLedgerData?.responseData?.filter((item) => {
				return item?.cancelStatus?.toLowerCase() !== 'cancelled';
			})
		: [];
	const groupedData = useMemo(() => groupDataByHead(filteredData), [filteredData]);

	return (
		<CardAccordion
			title="Trial Balance"
			customHeaderSX={accordionHeaderSx}
			typographySX={accordionTitleSx}
			darkTitle={true}
			sx={accordionSx}
			contentSX={{ p: 2 }}
		>
			<Box>
				<Spin spinning={isSendControlDataLoading || groupedData === null} style={{ maxHeight: '100%' }}>
					{generalLedgerData?.responseData?.length !== 0 ? (
						<TableContainer
							component={Paper}
							elevation={0}
							sx={{
								mb: 1,
								border: '1px solid #e6ebf2',
								borderRadius: '10px',
								overflow: 'hidden',
								boxShadow: 'none',
							}}
						>
							<Table>
								<TableHead>
									<TableRow sx={{ backgroundColor: '#f8fafc' }}>
										<TableCell
											sx={{
												fontWeight: 600,
												color: '#1f2937',
												fontSize: '13px',
												borderBottom: '1px solid #e6ebf2',
											}}
										>
											Account Head
										</TableCell>
										<TableCell
											align="right"
											sx={{
												fontWeight: 600,
												color: '#1f2937',
												fontSize: '13px',
												borderBottom: '1px solid #e6ebf2',
											}}
										>
											Cumulative Amount
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{Array.isArray(groupedData) && groupedData.length > 0 ? (
										groupedData.map((group, index) => (
											<TableRow key={index} sx={{ '&:nth-of-type(even)': { backgroundColor: '#fcfcfd' } }}>
												<TableCell sx={{ fontSize: '13px', color: '#344054', borderBottom: '1px solid #e6ebf2' }}>
													{group.head}
												</TableCell>
												<TableCell
													align="right"
													sx={{
														fontSize: '13px',
														color: '#101828',
														fontVariantNumeric: 'tabular-nums',
														borderBottom: '1px solid #e6ebf2',
													}}
												>
													{group.finalCumulativeAmount}
												</TableCell>
											</TableRow>
										))
									) : (
										<TableRow>
											<TableCell colSpan={2} align="center" sx={{ py: 3, color: '#667085' }}>
												No data available
											</TableCell>
										</TableRow>
									)}
								</TableBody>
							</Table>
						</TableContainer>
					) : (
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								minHeight: '120px',
								color: '#667085',
							}}
						>
							No Ledger Available Right Now
						</Box>
					)}
				</Spin>
			</Box>
		</CardAccordion>
	);
});

LeaseV9NewTrailModeBalanceView.displayName = 'TrialBalance';

export default LeaseV9NewTrailModeBalanceView;
